import { CommonModule } from '@angular/common';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { IPayments } from '@rfm/shared-interfaces';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { PaymentService } from '../../../../../shared/services/financial/payment.service.mjs';

@Component({
  selector: 'app-payment-view',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, CardModule, ButtonModule, ProgressSpinnerModule],
  templateUrl: './payment-view.component.html',
  styleUrls: ['./payment-view.component.scss'],
  encapsulation:ViewEncapsulation.None
})
export class PaymentViewComponent implements OnInit {
  object: IPayments | null = null; // Store the selected conduit details
  isLoading = false;

  constructor(private route: ActivatedRoute, private service: PaymentService) {}

  ngOnInit(): void {
    const id = this.route.snapshot.paramMap.get('id');
    if (id) {
      this.load(id);
    }
  }

  stripeLink() {
    return `https://dashboard.stripe.com/acct_1O87KxAawgYYcPfz/payments/${this.object?.integration_reference}`
  }

  load(id: string): void {
    this.isLoading = true;
    this.service.get(id)
      .then((response) => {
        this.object = response?.data ?? null; // Handle null or undefined data
        this.isLoading = false;
      })
      .catch((error) => {
        console.error('Error fetching subscription details:', error);
        this.isLoading = false;
      });
  }
}
